<template>

	<div class="container-fluid">

		<div class="row">
			<div class="col-md-6 col-lg-6 col-xl-6 mb-4">
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Existing Accounts</h4>
					</div>
					<div class="card-body">
						Here is a list of accounts, which you have access to see. The next release will have a full account search and browser (for authorized <u>superusers</u> only):
						<ul class="list-unstyled mt-3 mb-4">
							<li v-for="( account, index ) in getAccounts( )" :key="index">
								<router-link :to="'/nodes/'+ nodeId +'/accounts/'+ account.$id">{{account.name}} ({{account.$id}})</router-link>
							</li>
						</ul>
						<button class="btn btn-primary" @click.prevent="loadAccounts( true )"><i class="fas fa-sync-alt"></i> Refresh</button>
					</div>
				</div>
			</div>
			
			<div class="col-md-6 col-lg-6 col-xl-6 mb-4">

				<div class="card shadow-sm mb-4">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">New Account</h4>
					</div>
					<div class="card-body">
						<form autocomplete="off">
							<div class="form-group">
								<label for="newAccount_id">Username (and Account ID)</label>
								<input v-model="newAccountId" type="text" class="form-control" id="newAccount_id" aria-describedby="newAccount_idHelp" placeholder="Enter ID">
								<small id="newAccount_idHelp" class="form-text text-muted">Unique username which will also be the Account ID (e.g. "joesmith28")</small>
							</div>
							<div class="form-group">
								<label for="newAccount_email">Email Address</label>
								<input v-model="newAccountEmail" type="email" class="form-control" id="newAccount_email" aria-describedby="newAccount_emailHelp" placeholder="Enter email address">
								<small id="newAccount_emailHelp" class="form-text text-muted">Primary email address for the account (e.g. "jsmith28@testmail.com")</small>
							</div>
							<div class="form-group">
								<label for="newAccount_password">Password</label>
								<input v-model="newAccount.$$password" type="password" class="form-control" id="newAccount_password" aria-describedby="newAccount_passwordHelp" placeholder="Enter new password" autocomplete="new-password">
								<small id="newAccount_passwordHelp" class="form-text text-muted">Password for the new account</small>
							</div>
							<div class="form-group">
								<label for="newAccount_name">Full Name</label>
								<input v-model="newAccount.name" type="text" class="form-control" id="newAccount_name" aria-describedby="newAccount_nameHelp" placeholder="Enter full name">
								<small id="newAccount_nameHelp" class="form-text text-muted">Full name for the account (e.g. "Joe R. Smith")</small>
							</div>
							<div class="form-group">
								<label for="newAccount_desc">Description</label>
								<textarea v-model="newAccount.description" type="text" class="form-control" id="newAccount_desc" aria-describedby="newAccount_descHelp" placeholder="Enter description" rows="2"></textarea>
								<small id="newAccount_descHelp" class="form-text text-muted">Descriptive details (e.g. "This is a testing account")</small>
							</div>
							<div class="form-check" v-if="currentSessionAccount.roles && currentSessionAccount.roles.admin === true">
								<input v-model="newAccount.roles.admin" type="checkbox" class="form-check-input" id="newAccount_admin">
								<label class="form-check-label" for="newAccount_admin" aria-describedby="newAccount_adminHelp">Administrator <small class="text-muted">(superuser access to this entire node)</small></label>
							</div>
							
							<button class="btn btn-success mt-4" @click.prevent="createAccountFromData"><i class="fas fa-star"></i> Create New Account</button>
						</form>
					</div>
				</div>

				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Create New Account (JSON)</h4>
					</div>
					<div class="card-body">
						<div id="editor"></div>
						<button class="btn btn-success mt-4" @click.prevent="createAccountFromEditor"><i class="fas fa-star"></i> Create</button>
					</div>
				</div>

			</div>
		</div>
	</div>

</template>

<script>
import 'ace-builds';
import 'ace-builds/webpack-resolver';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import _ from 'lodash';

export default {
	name: "accounts-view",
	props: [ 'nodeId' ],
	data() {
		return {
			newAccountEmail: "",
			newAccountId: "",
			newAccount:
			{
				$id : "<optional-custom-id>",
				$schema : "sys:account.",
				name : "",
				username : "<login-username>",
				$$password : "",
				email: {
					"<email-address-1>": {
						"primary": true
					},
					"<email-address-2>": { }
				},
				roles: { }
			},
			accountList : []
		};
	},
	watch:
	{
		newAccount:
		{
			handler: function( newValue, oldValue )
			{
				this.editor.setValue( JSON.stringify( this.newAccount, null, 2 ), -1 );
			},
			deep : true
		},
		newAccountEmail( newValue, oldValue )
		{
			this.newAccount.email = {
				[newValue] : { primary : true }
			}
		},
		newAccountId( newValue, oldValue )
		{
			this.newAccount.$id = newValue;
			this.newAccount.username = newValue;
		}
	},
	components: { },
	computed:
	{
		currentSession: function( )
		{
			try {
				let sessionGuid = this.activeSession( this.nodeId );
				let [ sNode, sKey ] = sessionGuid.split( "/" );
				let session = this.session( sessionGuid );
				return session;
			} catch( err ) { }
			return null;
		},
		currentSessionAccount: function( )
		{
			try {
				let session = this.currentSession;
				let account = this.account( sNode, session.account );
				if( account )
					return account;
			} catch( err ) { }
			return { };	// No session.
		},
		...mapGetters( "accounts", {
			accounts: "accounts",
			account: "account",
		}),
		...mapGetters( "authentication", {
			activeSession: "activeSession",
			session: "session"
		}),
	},
	methods: {
		...mapActions({
			listAccounts: "accounts/list",
			readAccount: "accounts/read",
			createAccount: "accounts/create",
		}),
		getAccounts( )
		{
			return this.accounts( this.nodeId );
		},
		async createAccountFromData( )
		{
			// TODO: Set loading overlay
			await this.createNewAccount( this.newAccount );
		},
		async createAccountFromEditor( )
		{
			// TODO: Set loading overlay
			let account;

			try {
				account = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "Account format issue:\n"+ err.message );
				console.error( err );
				return;
			}

			await this.createNewAccount( account );
		},
		async createNewAccount( account )
		{
			if( !account.name ) return alert( "Must define a account Name ('name' field)" );
			if( !account.username ) return alert( "Must define a account Username ('username' field)" );
			if( !account.$$password ) return alert( "Must define a account Password ('$$password' field)" );

			try {
				let result = await this.createAccount( { nodeId : this.nodeId, newAccount : account } );
				if( !result.$id )
					throw new Error( "Result from account creation came back without an ID!" );
				this.accountList = this.accounts( this.nodeId );
				this.$router.push( { name : 'account', params : { nodeId : this.nodeId, accountId : result.$id } } );
				// TODO: close loading overlay
			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "Account creation failed:", err );
				alert( "Account creation failed!\n"+ err.message );
				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
			}
		},
		async checkMySession( )
		{
			try {
				let sessionGuid = this.$store.getters['authentication/activeSession']( this.nodeId );
				return await this.$store.dispatch( 'authentication/checkSession', { nodeId : this.nodeId, sessionKey : sessionGuid } );
			} catch( err ) { console.error( err ); return null; }
		},
		async loadAccounts( nocache )
		{
			try {
				await this.listAccounts( { nodeId : this.nodeId, nocache : nocache } );
				this.accountList = this.accounts( this.nodeId );
			} catch( err ) {
				if( err.response && ( err.response.status === 401 ) )
				{
					console.warn( "Session expired, invalid or missing.." );
					this.checkMySession( );
				}
				if( err.response && ( err.response.status === 403 ) )
				{
					console.warn( "You are not authorized to list accounts!" );
					let mySession = this.currentSession;
					if( mySession && typeof mySession === 'object' )
					{
						console.log( "You will be taken to your own account page." );
						this.$router.push( { name : 'account', params : { nodeId : this.nodeId, accountId : mySession.account } } );
					}
					else
					{
						console.warn( "Session expired, invalid or missing.." );
						this.checkMySession( );
					}
				}
				else
					throw err;
			}
		},
	},
	async created( )
	{
		this.accountList = this.getAccounts( );	// Get accounts from cache.
		try {
			await this.loadAccounts( true );	// Reload accounts in the background to make sure we have the latest.
		} catch( err ) { }
	},
	async mounted( )
	{
		try {
			this.editor = ace.edit( "editor", {
				mode: "ace/mode/json",
				theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
				maxLines: 20,
				minLines: 5,
				fontSize: 14,
				showPrintMargin : false
			});
			this.editor.setValue( JSON.stringify( this.newAccount, null, 2 ), -1 );
		} catch( err ) { throw err; }
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
	font-weight: normal;
}
div#editor
{
	border: 1px solid #666;
}
</style>


// WEBPACK FOOTER //
// src/components/Accounts.vue